export default __webpack_public_path__ + "static/media/gallery-wip-emitter-shroud_05.c0b052d7.jpg";